import PropTypes from 'prop-types';

import {THEMES} from '@asdf-constants';

export const Props = {
  /**
   * The theme of the divider
   */
  theme: PropTypes.oneOf(Object.values(THEMES)),
  /**
   * The variant/style of the divider
   */
  variant: PropTypes.oneOf(['solid', 'dashed', 'dotted']),
  /**
   * If true, the divider is displayed thicker than usual
   */
  fat: PropTypes.bool,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
